<template>
  <div class="date-device-filters">
    <div id="datepicker-trigger" class="date-picker" @click="toggleDatePicker">
      <div class="datebox-left datebox startDate">
        <CalendarIcon />
        <div class="datepicker-date">{{ formatDate(fromDatePick) }}</div>
      </div>
      <div class="arrow-right" />
      <div class="arrow-right2" />
      <div class="datebox datebox-right endDate">
        <CalendarIcon />
        <div class="datepicker-date">{{ formatDate(toDatePick) }}</div>
      </div>
    </div>
    <AirbnbStyleDatepicker
      :trigger-element-id="'datepicker-trigger'"
      :mode="'range'"
      :fullscreen-mobile="true"
      :date-one="fromDatePick"
      :date-two="toDatePick"
      :min-date="minDate"
      :max-date="maxDate"
      :trigger="showDates"
      :show-shortcuts-menu-trigger="false"
      :style="{ top: '80px' }"
      @closed="showDates = false"
      @apply="showDates = false"
      @date-one-selected="updateDate('fromDatePick', $event)"
      @date-two-selected="updateDate('toDatePick', $event)"
    />
  </div>
</template>

<script>
import CalendarIcon from "@/assets/svg/dashboard/calendar.svg?inline";
import monthNames from "@/utils/monthNames";

export default {
  components: {
    CalendarIcon,
  },
  props: {
    firstInitDoneProp: {
      type: Boolean,
      default: false,
    },
    siteId: {
      type: String,
      default: "",
    },
  },
  data() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fromDate = new Date(today);
    fromDate.setMonth(today.getMonth() - 1);
    fromDate.setHours(0, 0, 0, 0);

    return {
      fromDatePick: fromDate,
      toDatePick: today,
      showDates: false,
      monthNames,
      previousDates: {
        from: new Date(fromDate),
        to: new Date(today),
      },
    };
  },
  computed: {
    minDate() {
      const d = new Date();
      d.setMonth(d.getMonth() - 18);
      d.setHours(0, 0, 0, 0);
      return d;
    },
    maxDate() {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    },
    maxRangeDate() {
      const maxDate = new Date(this.fromDatePick);
      maxDate.setMonth(maxDate.getMonth() + 3);
      return maxDate > this.maxDate ? this.maxDate : maxDate;
    },
  },
  created() {
    if (this.$store.state.account.user.siteId !== "f1eb6d75-56cd-4808-83d5-2265e156034c")
      this.enforceDateConstraints();
  },
  methods: {
    startOfDay(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    },

    toggleDatePicker() {
      this.showDates = !this.showDates;
      if (this.showDates) {
        this.previousDates = {
          from: new Date(this.fromDatePick),
          to: new Date(this.toDatePick),
        };
      }
    },

    formatDate(date) {
      const newDate = new Date(date);
      return `${
        this.monthNames[newDate.getMonth()]
      } ${newDate.getDate()}, ${newDate.getFullYear()}`;
    },

    enforceDateConstraints() {
      if (this.fromDatePick < this.minDate) {
        this.fromDatePick = new Date(this.minDate);
      }
      if (this.fromDatePick > this.maxDate) {
        this.fromDatePick = new Date(this.maxDate);
      }
      if (this.toDatePick > this.maxDate) {
        this.toDatePick = new Date(this.maxDate);
      }

      let maxRange = new Date(this.fromDatePick);
      maxRange.setMonth(maxRange.getMonth() + 3);
      if (maxRange > this.maxDate) maxRange = this.maxDate;

      if (this.toDatePick > maxRange) {
        this.toDatePick = new Date(maxRange);
      }

      if (this.toDatePick < this.fromDatePick) {
        this.toDatePick = new Date(this.fromDatePick);
      }
    },

    updateDate(type, value) {
      if (!value || !this.firstInitDoneProp) return;

      const normalizedValue = this.startOfDay(value);

      if (type === "fromDatePick") {
        this.fromDatePick = normalizedValue;
      } else {
        this.toDatePick = normalizedValue;
      }

      if (this.$store.state.account.user.siteId !== "f1eb6d75-56cd-4808-83d5-2265e156034c")
        this.enforceDateConstraints();

      if (this.haveDatesChanged()) {
        this.$emit("dates-changed", this.fromDatePick, this.toDatePick);
      }
    },

    haveDatesChanged() {
      return (
        this.startOfDay(this.fromDatePick).getTime() !==
          this.startOfDay(this.previousDates.from).getTime() ||
        this.startOfDay(this.toDatePick).getTime() !==
          this.startOfDay(this.previousDates.to).getTime()
      );
    },
  },
};
</script>

<style lang="scss">
/* We need this additional tag to override the Multiselect component default styles */
@import "~vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";

.asd__wrapper--datepicker-open {
  z-index: map-get($zindex, colorPicker) !important;
}
</style>
<style lang="scss" scoped>
svg {
  path {
    fill: currentColor;
  }
}

.date-picker {
  display: flex;
  color: #fff;
  @include font-smaller;
  cursor: pointer;
  height: 30px;
  width: 300px;
  box-sizing: border-box;

  .datebox {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 50%;
    height: 30px;
  }

  .datebox-left {
    border-radius: 3px 0px 0px 3px;
  }

  .datebox-right {
    border-radius: 0px 3px 3px 0px;
  }

  .startDate {
    background-color: $pink;
  }

  .endDate {
    background-color: $dark-purple;
  }

  .arrow-right {
    width: 0;
    height: 0;
    border-top: 14px solid $dark-purple;
    border-bottom: 16px solid $dark-purple;
    border-left: 16px solid $pink;
  }
}
</style>
